import React, { useContext } from "react";
import styled from "styled-components";
import { WidgetContext } from "../WidgetContext";
import css from "classnames";
import MessagePopupHeader from "./MessagePopupHeader";
import Toast from "./Toast";
import ChatMessageForm from "./ChatMessageForm";

  export default styled(({ className, ...rest }: any) => {
    const { state } = useContext(WidgetContext);
    const pinLeft = state.config?.smswidgetconfig?.pin_left;
    return (
      <div
        className={css(
          "tecobi-message-popup",
          { open: state.isPopupOpen, left: pinLeft },
          className
        )}
        {...rest}
      >
        <MessagePopupHeader />
        <ChatMessageForm/>
        <Toast />
      </div>
    );
  })`
    background-color: rgb(242, 244, 246);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    font-family: Roboto, "Helvetica Neue", sans-serif;
    line-height: 1.3;

    opacity: 0;
    display: none;

    // Mobile devices
    @media screen and (max-width: 599px) {
      width: 100%;
      height: 100%;
      position: fixed;
      z-index: 20000000000;
      line-height: 1.3;
      top: 0px;
    }
    left: 0;
    right: 0;
    // Desktop devices
    @media screen and (min-width: 600px) {
      max-width: none;
      width: 450px;
      min-width: 400px;
      position: fixed;
      bottom: 79px;
      right: -20px;
      z-index: 99999999000;
      margin-right: 10px;
      line-height: 1.3;

      &:after {
        border: solid 12px transparent;
        border-top-color: rgb(242, 244, 246);
        content: "";
        display: block;
        position: absolute;
        bottom: 0;
        right: 50px;
        transform: translate(0, 100%);
        z-index: 1000;
      }
      right: 10px;
      left: unset;
      &.left {
        left: 10px;
        right: unset;
      }
      &.left::after {
        left: 50px;
        right: unset;
      }
    }
    @keyframes animScale {
        0% {
            opacity: 0;
            bottom: 0px;
            transform: scale(0.7);
        }

        100% {
            opacity: 1;
            transform: scale(1);
            bottom: 79px;
        }
    }
    animation-name: animScale;
    animation-duration: 0.3s;
    &.open {
      display: block;
      pointer-events: initial;
      opacity: 1;
    }
  `;
